import { render, staticRenderFns } from "./BriefFolderRenameModal.vue?vue&type=template&id=6a26b542"
import script from "./BriefFolderRenameModal.vue?vue&type=script&lang=js"
export * from "./BriefFolderRenameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports